import React from 'react';
import { CommonComboProps } from '../../../types/common';
import Dropdown from '../Dropdown';
import Textbox from '../Textbox';

type ComboboxProps = CommonComboProps;

const Combobox: React.FC<ComboboxProps> = ({
  name,
  displayText,
  options,
  hasErrors,
  className,
  autoComplete,
  defaultValue,
  disabled,
  readOnly,
  register,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
}: ComboboxProps) => {
  const readOnlyInputStyle = readOnly ? ' text-gray-400' : '';
  const comboBoxClass = `${className || ''}
  ${readOnlyInputStyle} border-1-half rounded border-transparent
    focus:border-[color:var(--form-accent-color)] outline-none pl-3
    checkout-panel-form-input`;

  if (options && options.length) {
    return (
      <Dropdown
        name={name}
        displayText={displayText}
        options={options}
        hasErrors={hasErrors}
        className={comboBoxClass}
        register={register}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        onChange={onChange}
      />
    );
  }
  return (
    <Textbox
      name={name}
      hasErrors={hasErrors}
      className={comboBoxClass}
      register={register}
      disabled={disabled}
      readOnly={readOnly}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      autoComplete={autoComplete}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default Combobox;
